import React, { FC } from 'react'
import get from 'lodash/get'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'

import Register from '../components/Register'

import { actionCreators } from '../actions'
import { setCustomer } from '@/checkout-instore-legacy/order/actions'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import useNetwork from '@/checkout-instore-legacy/hooks/useNetwork'

const RegisterContainer: FC = (props) => {
  const registerProps = {
    ...props,
    isOnline: useNetwork(),
  }

  return <Register {...registerProps} />
}

const mapStateToProps = (state: RootState) => ({
  customer: state.customer,
  loading: state.customer.loading,
  checkoutLoading: state.customer.checkoutLoading,
  showInvoiceAddressOnRegister: get(getInstoreConfig(), [
    'customerProfile',
    'showInvoiceAddressOnRegister',
  ]),
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators({ ...actionCreators, setCustomer }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContainer)
